<template>
  <div>
    <div>
      <!-- Name Input -->
      <div v-if="!hasST" class="col form-group mb-4">
        <input
          ref="cpfInput"
          id="cpf"
          v-model="obj.cpf"
          v-mask="'###.###.###-##'"
          class="w-100"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          :placeholder="$t('cpfVerification.placeholder')"
          type="text"
          tabindex="-1"
        />
      </div>

      <!-- Foreign case -->
      <div
        v-if="!hasST && !config.disableForeignerRegistration"
        style="cursor: pointer; text-decoration: underline"
        class="text-center rounded-md text-white mr-3"
        @click="jumpCPFVerification"
      >
        {{ $t('cpfVerification.notInBrazil') }}
      </div>

      <!-- Verification Code Input -->
      <div v-if="hasST" class="text-white">
        <div class="col" v-html="$t('cpfVerification.cpfEmailAssociated')"></div>

        <div class="col form-group my-4">
          <input
            ref="codeInput"
            id="code"
            v-model="obj.verificationCode"
            class="w-100 c-input"
            :placeholder="$t('cpfVerification.verificationCodePlaceholder')"
            type="text"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'
import { loginFB } from '../../services/ServFB.js'

const lFB = new loginFB()

/* Helpers */
import { mask } from 'vue-the-mask'
import axios from 'axios'

export default {
  name: 'CpfVerification',
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    hasST: false,
    toastMessage: '',
  }),
  computed: {
    ...mapState(['template', 'config', 'subdomain', 'registrationObject']),
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  mounted() {
    // Create a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))

    document.getElementById('cpf').focus()
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    async validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (!this.obj.cpf) {
        hasErrors = true
        this.addRegistrationError({ msg: this.$t('cpfVerification.cpfRequired') })
      }
      if (!this.checkCPF(this.obj.cpf)) {
        hasErrors = true
        this.addRegistrationError({ msg: this.$t('cpfVerification.cpfInvalid') })
      }

      if (!hasErrors) {
        if (this.hasST) {
          this.checkEmailCodeToConfirmService(this.obj.verificationCode, this.obj.email)
        } else {
          if (this.config.checkAccountV2) {
            await this.checkAccountV2(this.obj.cpf)
          } else {
            await this.checkExistingCpf(this.obj.cpf)
          }
        }
        //this.$store.commit('updateRegistrationObject', this.obj);
        //this.$emit('next');
      }
    },

    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: `Erro`,
        variant: variant,
        solid: true,
      })
    },

    getCEP(cep) {
      let ceptext = cep.replace('-', '')
      const url = `https://viacep.com.br/ws/${ceptext}/json/`

      axios.get(url).then(response => {
        this.obj.estado = response.data.estado
        this.obj.uf = response.data.uf
      })
    },

    async checkAccountV2(cpf) {
      try {
        const userData = await lFB.checkLoginV2(cpf, this.config.ownerId, this.config.name)
        if (
          userData.userAccount ||
          userData.action === 'RedirectLogin' ||
          userData.action === 'ExistingAccount'
        ) {
          if (
            (userData.action === 'RedirectLogin' || userData.action === 'ExistingAccount') &&
            userData.actionData &&
            userData.actionData.message
          ) {
            this.toastMessage = userData.actionData.message
          } else {
            this.toastMessage = 'Esse CPF já está associado a uma conta. Faça login para continuar.'
          }
          this.makeToast('danger')
        } else if (this.hasValidUserData(userData)) {
          this.hasST = true

          const { email, phone, name, cpf, extendedAccInfo } = userData
          Object.assign(this.obj, {
            email,
            phone,
            firstName: name,
            cpf,
          })

          if (extendedAccInfo) {
            const { birthdate, gender, address } = extendedAccInfo
            Object.assign(this.obj, {
              birthDate: birthdate,
              gender,
              cep: (address && address.zip) || '',
              localidade: (address && address.city) || '',
              logradouro: (address && address.street) || '',
              numero: (address && address.number) || '',
              complement: (address && address.complement) || '',
              bairro: (address && address.nh) || '',
            })

            if (address && address.zip) {
              this.getCEP(address.zip)
            }
          }
        } else {
          const {
            sendEmailDirect,
            identity,
            phone,
            email,
            name,
            socialName,
            birthDate,
            gender,
            zipCode,
            state,
            city,
            street,
            number,
            neighborhood,
            complement,
          } = userData.actionData

          this.$store.commit('setIdentity', identity)
          this.$store.commit('setPhoneFromCpfVerification', phone)

          if (email) {
            this.$store.commit('emailToSendConfirmateCode', email)
          }

          Object.assign(this.obj, {
            phone: phone ? this.$store.state.phoneFromCpfVerification : this.obj.phone,
            firstName: (name || '').trim() || this.obj.firstName,
            socialName: (socialName || '').trim() || this.obj.socialName,
            birthDate: birthDate || this.obj.birthDate,
            gender: gender
              ? gender.toLowerCase() === 'm'
                ? 'M'
                : gender.toLowerCase() === 'f'
                ? 'F'
                : 'N'
              : this.obj.gender,
          })

          if (zipCode) {
            const { dataViaCep } = await axios.get(`https://viacep.com.br/ws/${zipCode}/json/`)
            const addressViaCep = dataViaCep || {}

            Object.assign(this.obj, {
              cep: zipCode,
              uf: state || addressViaCep.uf,
              localidade: city || addressViaCep.localidade,
              logradouro: street || addressViaCep.logradouro,
              bairro: neighborhood || addressViaCep.bairro || '',
              numero: number || '',
              complement: complement || addressViaCep.complemento || '',
            })
          }

          if (sendEmailDirect || userData.action === 'ConfirmEmail') {
            this.$store.commit('updateRegistrationObject', this.obj)
            this.sendEmailCodeToConfirmService(identity)
          } else {
            this.obj.cpf = this.obj.cpf.replace(/\D/g, '')
            this.$store.commit('updateRegistrationObject', this.obj)
            this.$emit('next')
          }
        }
      } catch (err) {
        console.error(err)
        this.toastMessage =
          'Ocorreu um erro ao processar seu cadastro. Por favor, contate o suporte.'
        this.makeToast('danger')
      }
    },

    //consultar no banco para ver se o CPF está correto
    async checkExistingCpf(cpf) {
      try {
        const userData = await lFB.checkLogin(cpf, this.config.ownerId, this.config.name)
        if (userData.userAccount) {
          this.toastMessage = 'Esse CPF já está associado a uma conta. Faça login para continuar.'
          this.makeToast('danger')
        } else if (this.hasValidUserData(userData)) {
          this.hasST = true

          const { email, phone, name, cpf, extendedAccInfo } = userData
          Object.assign(this.obj, {
            email,
            phone,
            firstName: name,
            cpf,
          })

          if (extendedAccInfo) {
            const { birthdate, gender, address } = extendedAccInfo
            Object.assign(this.obj, {
              birthDate: birthdate,
              gender,
              cep: (address && address.zip) || '',
              localidade: (address && address.city) || '',
              logradouro: (address && address.street) || '',
              numero: (address && address.number) || '',
              complement: (address && address.complement) || '',
              bairro: (address && address.nh) || '',
            })

            if (address && address.zip) {
              this.getCEP(address.zip)
            }
          }
        } else {
          const { sendEmailDirect, identity, phone } = userData

          this.$store.commit('setIdentity', identity)
          this.$store.commit('setPhoneFromCpfVerification', phone)

          if (phone) {
            this.obj.phone = this.$store.state.phoneFromCpfVerification
            this.$store.commit('updateRegistrationObject', this.obj)
          }

          if (sendEmailDirect) {
            this.$store.commit('updateRegistrationObject', this.obj)
            this.sendEmailCodeToConfirmService(identity)
          } else {
            this.obj.cpf = this.obj.cpf.replace(/\D/g, '')
            this.$store.commit('updateRegistrationObject', this.obj)
            this.$emit('next')
          }
        }
      } catch (err) {
        this.toastMessage = err
        this.makeToast('danger')
      }
    },

    hasValidUserData(userData) {
      return userData && !!userData.tags && !!userData.email && !!userData.cpf
    },

    //enviar e-mail para salvar no banco o code

    async sendEmailCodeToConfirmService(identity) {
      try {
        const res = await lFB.sendEmailCodeToConfirm(
          '',
          identity,
          this.config.ownerId,
          this.config.name,
        )
        if (res.data.header.codigo === 1) {
          this.$emit('next-email-check-code')
        } else {
          const warningMsg =
            'Algo não ocorreu bem ao enviar o código de verificação. Tente novamente mais tarde.'
          this.addRegistrationError({
            msg: warningMsg,
          })
          this.toastMessage = warningMsg
          this.makeToast('danger')
        }
      } catch (err) {
        this.toastMessage = err
        this.makeToast('danger')
      }
    },
    //consultar no banco para ver se o code está correto
    async checkEmailCodeToConfirmService(code, email) {
      try {
        const res = await lFB.checkEmailCodeToConfirm(code, email, this.config.name)
        if (res === 1) {
          this.obj.code = code
          this.obj.cpf = this.obj.cpf.replace(/\D/g, '')
          this.$store.commit('updateRegistrationObject', this.obj)
          this.$emit('next')
        } else {
          const warningMsg = this.$t('email.codeInvalid')
          this.addRegistrationError({
            msg: warningMsg,
          })
          this.toastMessage = warningMsg
          this.makeToast('danger')
        }
      } catch (err) {
        this.toastMessage = err
        this.makeToast('danger')
      }
    },

    checkCPF(value) {
      if (!value || !value.length) return false

      let cpf = value.replace(/[^\d]/g, '')

      if (
        cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999'
      ) {
        return false
      }

      let sum
      let remainder
      let i

      sum = 0

      for (i = 1; i <= 9; i++) {
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i)
      }

      remainder = (sum * 10) % 11

      if (remainder === 10 || remainder === 11) {
        remainder = 0
      }

      if (remainder !== parseInt(cpf.substring(9, 10))) {
        return false
      }

      sum = 0

      for (i = 1; i <= 10; i++) {
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i)
      }

      remainder = (sum * 10) % 11

      if (remainder === 10 || remainder === 11) {
        remainder = 0
      }

      if (remainder !== parseInt(cpf.substring(10, 11))) {
        return false
      }

      return true
    },

    jumpCPFVerification() {
      this.$emit('next')
    },
  },
}
</script>
<style></style>
